import { RootState } from '../../../redux/store';
import { IOnAccountPaymentOptionsState } from '../initialStates/onAccountPaymentOptions';

export const selectOnAccountPaymentOptions = (state: RootState): IOnAccountPaymentOptionsState =>
  state.onAccountPaymentOptions;
